import { loadCompositions } from "./storage.js";

const SUITS = ["action", "observation", "relation"];

export function mountLibrary(rootEl, { onOpen, onNew }) {
  rootEl.innerHTML = `
    <section class="library-section">
      <header class="section-head">
        <h3 class="section-title">Your library</h3>
        <div style="display:flex;gap:12px;align-items:center;">
          <span class="section-count"><span id="lib-num">0</span> times</span>
          <button class="reveal-btn" id="new-comp-btn">+ new composition</button>
        </div>
      </header>
      <div id="lib-grid" class="comp-grid"></div>
    </section>
  `;
  const elNum = rootEl.querySelector("#lib-num");
  const elGrid = rootEl.querySelector("#lib-grid");
  rootEl.querySelector("#new-comp-btn").addEventListener("click", () => onNew());

  function render() {
    const comps = loadCompositions().slice().sort((a, b) => (b.updatedAt || b.createdAt) - (a.updatedAt || a.createdAt));
    elNum.textContent = comps.length.toString();
    if (comps.length === 0) {
      elGrid.innerHTML = '<div class="empty">No compositions yet. Open packs, arrange cards on a canvas.</div>';
      return;
    }
    elGrid.innerHTML = "";
    for (const comp of comps) {
      const used = new Set((comp.cards || []).map((c) => c.suit));
      const dots = SUITS.filter((s) => used.has(s)).map((s) => `<span class="comp-suit-dot ${s}"></span>`).join("");
      const el = document.createElement("div");
      el.className = "comp-thumb";
      el.innerHTML = `
        <div class="comp-thumb-title">${escapeHtml(comp.title || "Untitled")}</div>
        <div class="comp-thumb-desc">${escapeHtml(comp.description || "")}</div>
        <div class="comp-thumb-foot">
          <span>${(comp.cards || []).length} cards</span>
          <span class="comp-thumb-suits">${dots}</span>
        </div>
      `;
      el.addEventListener("click", () => onOpen(comp.id));
      elGrid.appendChild(el);
    }
  }

  return { render };
}

function escapeHtml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
